import NextImage, { ImageProps as NextImageProps } from 'next/image';
import { FC } from 'react';

export interface ImageProps extends NextImageProps {}

const Image: FC<ImageProps> = (props) => {
  return <NextImage {...props} loading={'eager'} />;
};

export default Image;
